<template>
  <section class="page-section">
    <el-alert
      title="仅待审批申领单允许取消；已通过和已驳回记录可查看审批结果。"
      type="info"
      :closable="false"
      show-icon
    />

    <el-table :data="requests.list" class="business-table">
      <el-table-column prop="suppliesName" label="用品名称" min-width="150" />
      <el-table-column prop="quantity" label="申领数量" width="100" />
      <el-table-column prop="reason" label="用途说明" min-width="200" show-overflow-tooltip />
      <el-table-column prop="createTime" label="申请时间" width="180" />
      <el-table-column label="审批状态" width="100">
        <template #default="{ row }">
          <el-tag :type="requestTagType(row.applyStatus)">
            {{ requestStatusLabel(row.applyStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="rejectReason" label="审批信息" min-width="180" show-overflow-tooltip />
      <el-table-column label="操作" width="120">
        <template #default="{ row }">
          <el-button
            v-if="row.applyStatus === 0"
            type="danger"
            link
            @click="handleCancel(row)"
          >
            取消申领
          </el-button>
          <span v-else class="muted-text">不可操作</span>
        </template>
      </el-table-column>
    </el-table>

    <div v-if="requests.totalElements > 0" class="pager">
      <span class="pager-text">第 {{ filters.page }} / {{ totalPages }} 页</span>
      <el-button :disabled="filters.page <= 1" @click="handlePrevPage">
        <el-icon><ArrowLeft /></el-icon>
        上一页
      </el-button>
      <el-button type="primary" :disabled="filters.page >= totalPages" @click="handleNextPage">
        下一页
        <el-icon><ArrowRight /></el-icon>
      </el-button>
    </div>
  </section>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus'
import { ArrowLeft, ArrowRight } from '@element-plus/icons-vue'
import {
  cancelEmployeeRequest,
  fetchEmployeeRequests
} from '../../services/employeeService'

export default {
  name: 'EmployeeRequestsPanel',
  components: {
    ArrowLeft,
    ArrowRight
  },
  data() {
    return {
      requests: {
        list: [],
        total: 0,
        totalElements: 0
      },
      filters: {
        page: 1,
        pageSize: 10
      }
    }
  },
  computed: {
    totalPages() {
      const total = Number(this.requests.totalElements) || 0
      const pageSize = Number(this.filters.pageSize) || 10

      return Math.max(1, Math.ceil(total / pageSize))
    }
  },
  mounted() {
    this.loadRequests()
  },
  methods: {
    isCancelAction(error) {
      return error === 'cancel' || error === 'close'
    },
    requestTagType(status) {
      if (status === 0) return 'warning'
      if (status === 1) return 'success'
      if (status === 2) return 'danger'
      return 'info'
    },
    requestStatusLabel(status) {
      if (status === 0) return '待审批'
      if (status === 1) return '审批通过'
      if (status === 2) return '审批拒绝'
      return '已取消'
    },
    async loadRequests() {
      const response = await fetchEmployeeRequests(this.filters)
      this.requests = response.data
    },
    handlePageChange(page) {
      this.filters.page = page
      this.loadRequests()
    },
    handlePrevPage() {
      if (this.filters.page <= 1) {
        return
      }

      this.handlePageChange(this.filters.page - 1)
    },
    handleNextPage() {
      if (this.filters.page >= this.totalPages) {
        return
      }

      this.handlePageChange(this.filters.page + 1)
    },
    async handleCancel(row) {
      try {
        await ElMessageBox.confirm('确认取消该申领单吗？', '取消确认', {
          type: 'warning'
        })
        const response = await cancelEmployeeRequest(row.id)
        ElMessage.success(response.message || response.msg || '申领已取消')
        this.loadRequests()
      } catch (error) {
        if (!this.isCancelAction(error)) {
          ElMessage.error(error.message || '操作已取消')
        }
      }
    }
  }
}
</script>

<style scoped>
.page-section {
  display: grid;
  gap: 18px;
}

.business-table {
  border-radius: 20px;
  overflow: hidden;
}

.pager {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.pager-text {
  color: #475569;
  font-size: 14px;
  font-weight: 600;
}

.muted-text {
  color: #94a3b8;
}
</style>
